import request from '@/axios'

export function getAllRooms (customer_id, next_page_url) {
  let page_url = `/classes/get_assets/${customer_id}`
  if (next_page_url) {
    page_url = next_page_url
  }

  return request({
    url: page_url,
    method: 'GET'
  })
}

export function searchTeacherList (customer_id, payload) {
  return request({
    url: `/classes/get_staff_list/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function getAssignedTeacherList (customer_id, page_no, payload) {
  return request({
    url: `/classes/get_class_staff_list/${customer_id}?page=${page_no}`,
    method: 'POST',
    data: payload
  })
}

export function searchStudentList (customer_id, payload) {
  return request({
    url: `/classes/get_client_list/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function getAssignedStudentList (customer_id, page_no, payload) {
  return request({
    url: `/classes/get_class_client_list/${customer_id}?page=${page_no}`,
    method: 'POST',
    data: payload
  })
}

export function createClass (payload) {
  return request({
    url: '/classes/create',
    method: 'POST',
    data: payload
  })
}

export function getClassList (customer_id, page, payload, limit,query) {
  return request({
    url: `/classes/list/${customer_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${page}&limit=${limit}`,

    method: 'POST',
    data: payload
  })
}

export function getClassListWithoutPagination (customer_id, query) {
  return request({
    url: `/classes/schedules/${customer_id}/get-class-short-list?page=${query.page}`,
    method: 'GET'
  })
}

export function getClassDetails (customer_id, class_id) {
  return request({
    url: `/classes/show/${class_id}/${customer_id}`,
    method: 'GET'
  })
}

export function checkClassOverlap (payload) {
  return request({
    url: '/classes/schedules/check-class-overlap',
    method: 'POST',
    data: payload
  })
}

export function createClassSchedule (payload) {
  return request({
    url: '/classes/create_setting',
    method: 'POST',
    data: payload
  })
}

export function saveClassCurriculum (payload) {
  return request({
    url: '/classes/save_class_curriculam',
    method: 'POST',
    data: payload
  })
  
}

export function getCurricullum (payload) {
  return request({
    url: '/classes/list_class_curriculam',
    method: 'POST',
    data: payload
    
  })
}
export function getClassSchedule (customer_id, payload) {
  return request({
    url: `/classes/list_setting/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function createDuplicate (payload) {
  return request({
    url: 'classes/create_duplicate',
    method: 'POST',
    data: payload
  })
}

export function deleteCurricullumApi (payload) {
  return request({
    url: 'classes/delete_class_curriculam',
    method: 'POST',
    data: payload
  })
}
export function fetchClassTemp (customer_id) {
  return request({
    url: `classes/certificate_setting/list_template/${customer_id}`,
    method: 'GET'
  })
}

export function saveCertificateSettings (payload) {
  return request({
    url: 'classes/certificate_setting/save',
    method: 'POST',
    data: payload
  })
}

export function fetchClassUserList (payload, customer_id) {
  return request({
    url: `classes/get_class_user_list/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function subjectList (customer_id) {
  return request({
    url: `/classes/list_subject/${customer_id}`,
    method: 'GET'
  })
}

export function archiveClass (payload) {
  return request({
    url: '/classes/update_status',
    method: 'POST',
    data: payload
  })
}

export function deleteClass (customer_id, payload) {
  return request({
    url: `/classes/delete/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function saveChatSettings (payload) {
  return request({
    url: '/classes/chat_setting/save',
    method: 'POST',
    data: payload
  })
}

export function getGradeStructure (payload) {
  return request({
    url: '/classes/grades/structure',
    method: 'POST',
    data: payload
  })
}

export function saveGradeSettings (customer_id, payload) {
  return request({
    url: `/classes/grades/rules/update/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function getGradeSettings (customer_id, payload) {
  return request({
    url: `/classes/grades/rules/get/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function deleteGradeSettings (customer_id, payload) {
  return request({
    url: `/classes/grades/rules/delete/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function getGradeList (customer_id, page_no, payload) {
  return request({
    url: `/classes/student-answers/${customer_id}?page=${page_no}`,
    method: 'POST',
    data: payload
  })
}

export function getStudentAnswerDetail (customer_id, payload) {
  return request({
    url: `/classes/student-answer-detail/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function studentAnswersRemark (customer_id, payload) {
  return request({
    url: `/classes/student-answers-remark/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function studentAnswersRemarkReport (customer_id, payload) {
  return request({
    url: `/classes/student-answers-remark-report/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function generateStudentGradebook (customer_id, payload) {
  return request({
    url: `/classes/grades/generateGradeBook/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function gradebookUpdate (customer_id, payload) {
  return request({
    url: `/classes/grades/card/update/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function gradebookDownload (customer_id, payload) {
  return request({
    url: `/classes/grades/generateGradeBook/pdf/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function studentReportShare (customer_id, payload) {
  return request({
    url: `/classes/grades/share-gradebook/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function fetchClassBySearch (payload, page, limit,query) {
  return request({
    url: `classes/global_search?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${page}&limit=${limit}`,
    method: 'POST',
    data:payload
  })
}